import React, { useState } from 'react';

const API_URL = '';  // ✅ constants outside is fine


function ProductUpload({ token }) {
  // 👇 ALL hooks must be here, inside the function body
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isBulkMode, setIsBulkMode] = useState(false);
  const [formData, setFormData] = useState({ 
    name: '', 
    price: '', 
    type: 'album', 
    downloadEnabled: false,
    preorder: true,
    featured: false,
    preorderAvailable: false,
    preorders: 0,
    preorderGoal: null,
    preorderDeadline: '' 
    });
  

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!formData.name || !formData.price) {
    alert("Name and price are required");
    return;
  }

  setUploading(true);
  try {
    await Promise.all(files.map(async (file) => {
      const fd = new FormData();
      fd.append('name', formData.name);
      fd.append('price', formData.price);
      fd.append('type', formData.type);
      fd.append('featured', formData.featured);
      fd.append('downloadEnabled', formData.downloadEnabled);
      fd.append('downloadLink', formData.downloadLink);
      fd.append('preorderAvailable', formData.preorderAvailable);
      fd.append('preorderGoal', formData.preorderGoal);
      
      if (formData.preorderAvailable) {
        fd.append('preorderDeadline', formData.preorderDeadline);
      }
      
      fd.append('image', file);

      const res = await fetch('/api/admin/products', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: fd
      });

      if (!res.ok) throw new Error(`Upload failed: ${res.status}`);
    }));

    alert('✅ Products uploaded successfully!');
    setFiles([]);
    setFileInputKey(Date.now());
    setFormData({
     name: '', 
    price: '', 
    type: 'album', 
    downloadEnabled: false,
    preorder: true,
    featured: false,
    preorderAvailable: false,
    preorderDeadline: '' 
    });

  } catch (error) {
    alert(`❌ Error: ${error.message}`);
  } finally {
    setUploading(false);
  }
};

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 bg-white rounded shadow">
      <h2 className="text-xl font-bold">Upload Proucts</h2>

      {/* Bulk mode toggle */}
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={isBulkMode}
          onChange={(e) => setIsBulkMode(e.target.checked)}
        />
        Bulk Upload Mode
      </label>

      {/* File input */}
      <input
        key={fileInputKey}
        type="file"
        accept="image/*"
        multiple
        onChange={(e) => setFiles(Array.from(e.target.files))}
        className="border px-3 py-2 rounded w-full"
      />
      
<input
  type="text"
  placeholder="Name"
  value={formData.name}
  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
  className="border px-3 py-2 rounded w-full"
/>

      <input
        type="number"
        step="0.01"
        placeholder="Price"
        value={formData.price}
        onChange={(e) => setFormData({ ...formData, price: e.target.value })}
        className="border px-3 py-2 rounded w-full"
      />
      
      <select
        value={formData.type}
        onChange={(e) => setFormData({ ...formData, type: e.target.value })}
        className="border px-3 py-2 rounded w-full"
      >
        <option value="album">Album</option>
        <option value="novel">Novel</option>
        <option value="art">Art</option>
        <option value="tshirt">T-shirt</option>
        <option value="cap">Cap</option>
        <option value="hoodie">Hoodie</option>
         <option value="pdfprint">Pdfprint</option>
      </select>
      
 
          <div className="flex flex-col">
          <label className="flex items-center gap-2 h-10">
            <input
              type="checkbox"
              checked={formData.downloadEnabled}
              onChange={(e) => setFormData({ ...formData, downloadEnabled: e.target.checked })}
            />
            Enable Digital Download
          </label>
        </div>
     
<input
  type="number"
  placeholder="Preorder Goal"
  value={formData.preorderGoal}
  onChange={(e) => setFormData({ ...formData, preorderGoal: e.target.value })}
  className="border px-3 py-2 rounded w-full"
/>


      <div className="space-y-2">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={formData.preorderAvailable}
            onChange={(e) => setFormData({ 
              ...formData, 
              preorderAvailable: e.target.checked,
              preorderDeadline: e.target.checked ? new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0] : ''
            })}
          />
          Available for Preorder
        </label>

        {formData.preorderAvailable && (
          <div>
            <label className="block text-sm font-medium mb-1">Preorder Deadline</label>
            <input
              type="date"
              value={formData.preorderDeadline}
              min={new Date().toISOString().split('T')[0]}
              onChange={(e) => setFormData({ ...formData, preorderDeadline: e.target.value })}
              className="border px-3 py-2 rounded w-full"
            />
          </div>
        )}
      </div>

      {/* Existing fields */}
      <div className="flex items-center gap-2">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={formData.featured}
            onChange={(e) => setFormData({ ...formData, featured: e.target.checked })}
          />
          Featured Artwork
        </label>
      </div>

     
      {/* Image previews */}
      {files.length > 0 && (
        <div className="mt-3 grid grid-cols-3 gap-3">
          {files.map((file, index) => (
            <div key={index} className="border rounded p-2 text-center">
              <img
                src={URL.createObjectURL(file)}
                alt="preview"
                className="w-full h-24 object-contain mb-2"
              />
              <p className="text-xs truncate">{file.name}</p>
              <button
                type="button"
                onClick={() => setFiles(files.filter((_, i) => i !== index))}
                className="text-red-500 text-xs mt-1"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      )}

      <button
        type="submit"
        disabled={uploading}
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50"
      >
        {uploading ? 'Uploading...' : 'Upload Images'}
      </button>
    </form>
  );
}

export default ProductUpload;